import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import { Box, Button, Tooltip, Typography } from '@mui/material'
// displays edit icon
export function EditIconImg({
  onEdit,
  editName
}: {
  onEdit: () => void
  editName?: string
}) {
  return (
    <Tooltip title='Edit Customer Details'>
      <Button size='small' variant='noBackground' onClick={onEdit}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <EditIcon sx={{ fontSize: '16px' }} />
          <Typography sx={{ fontSize: '14px' }}>
            {editName ? editName : 'Edit'}
          </Typography>
        </Box>
      </Button>
    </Tooltip>
  )
}
